<template>
  <DataDownloadQuery
    :child-page-url="pageUrl"
  />
</template>

<script setup lang="ts">
import DataDownloadQuery from '@/modules/data-download/DataDownloadQuery.vue';
import { computed } from 'vue';

const props = defineProps({
  userInput: { type: Object, default: null }
});

const pageUrl = computed(() => props.userInput?.pageUrl);

</script>
